export const ClockIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_7518_73305)">
      <path
        d="M8 0C3.58214 0 0 3.58214 0 8C0 12.4179 3.58214 16 8 16C12.4179 16 16 12.4179 16 8C16 3.58214 12.4179 0 8 0ZM8 14.6429C4.33214 14.6429 1.35714 11.6679 1.35714 8C1.35714 4.33214 4.33214 1.35714 8 1.35714C11.6679 1.35714 14.6429 4.33214 14.6429 8C14.6429 11.6679 11.6679 14.6429 8 14.6429Z"
        fill="#999999"
      />
      <path
        d="M11.1197 10.261L8.57323 8.41992V4.00028C8.57323 3.92171 8.50895 3.85742 8.43037 3.85742H7.57145C7.49287 3.85742 7.42859 3.92171 7.42859 4.00028V8.91814C7.42859 8.96457 7.45002 9.00742 7.48752 9.03421L10.4411 11.1878C10.5054 11.2342 10.5947 11.2199 10.6411 11.1574L11.1518 10.461C11.1982 10.3949 11.1839 10.3056 11.1197 10.261Z"
        fill="#999999"
      />
    </g>
    <defs>
      <clipPath id="clip0_7518_73305">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
